import { useContext } from 'react';

import { Button, Header } from '@GxT-Team/gxt-components';

import { AuthoringHeaderProps } from './types';

import { GeneralizationContext } from '../../../../contexts/GeneralizationContext';
import { useMappingSessionAPI } from '../../../../services/api/mappingSession/useMappingSessionAPI';
import { useNavigate } from 'react-router-dom';
import { notifyError } from '../../../../helpers/utils';
import { StatusType } from '../../../../services/api/types';

const AuthoringHeader = ({
  isAutoMapping = false,
  isLoading,
  handleSave,
  handleClose,
}: AuthoringHeaderProps) => {
  const { sessionId, acceptedSuggestions, setSessionStatus } = useContext(GeneralizationContext);

  const { updateMappingSessionStatus } = useMappingSessionAPI();
  const { mutateAsync: updateSessionStatus, isPending } = updateMappingSessionStatus;

  const navigate = useNavigate();

  const statusUpdateHandler = async (status: string) => {
    if (sessionId) {
      try {
        await updateSessionStatus({ status, id: sessionId });
        setSessionStatus(status);
        // eslint-disable-next-line no-empty
      } catch (err) {
        console.error(err);
      }
    } else {
      console.error('Unable to find session ID');
    }
  };

  const handleFinish = async () => {
    if (acceptedSuggestions?.length) {
      await statusUpdateHandler('finished');
      navigate('/catalog');
    } else {
      notifyError('No mappings found');
    }
  };

  return (
    <Header>
      <Header.Heading className="!text-primary-400">
        {isAutoMapping ? 'Mapping' : 'Authoring'}
      </Header.Heading>
      <Header.Actions>
        {!isAutoMapping && (
          <>
            <Button variant="secondary" onClick={() => handleSave()} disabled={isLoading}>
              Save
            </Button>
          </>
        )}
        <Button variant="negative" onClick={handleClose} disabled={isPending}>
          Close
        </Button>
        <div className="h-10 border width-2 border-neutral-200" />
        {!isAutoMapping ? (
          <>
            <Button
              variant="primary"
              onClick={() => statusUpdateHandler(StatusType.READY_TO_REVIEW)}
              disabled={isPending}>
              Ready to Review
            </Button>
            <Button
              variant="secondary"
              onClick={() => statusUpdateHandler(StatusType.COMPLETED)}
              disabled={isPending}>
              Document Complete
            </Button>
          </>
        ) : (
          <Button variant="primary" onClick={handleFinish}>
            Finish
          </Button>
        )}
      </Header.Actions>
    </Header>
  );
};

export default AuthoringHeader;
